import React from 'react'
import { Link } from 'react-router-dom'

export default class About extends React.Component {
  componentDidMount() {
    document.title = 'About'
  }

  render() {
    return (
      <div>
        <section className="container fadeInUp photo">
          <div className="col-6-of-12">
            <img src={require('img/portrait.jpg')} />
          </div>
          <div className="col-5-of-12 pull-2">
            <h1>Sergi Miral</h1>
            <h2>Designer & Coder from Barcelona</h2>
          </div>
        </section>
        <section className="container fadeInUp profile">
          <div className="col-5-of-12">
            <h4>> about me:</h4>
          </div>
          <div className="col-7-of-12 link-border">
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Tum Torquatus: Prorsus, inquit, assentior; Qui autem esse poteris, nisi te amor ipse ceperit? De hominibus dici non necesse est. Duo Reges: constructio interrete.
            </p>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Saepe ab Aristotele, a Theophrasto mirabiliter est laudata per se ipsa rerum scientia; Quis est, qui non oderit libidinosam, protervam adolescentiam? Ut necesse sit omnium rerum, quae natura vigeant, similem esse finem, non eundem. Omnia contraria, quos etiam insanos esse vultis. Obsecro, inquit, Torquate, haec dicit Epicurus? Dicimus aliquem hilare vivere; Rapior illuc, revocat autem Antiochus, nec est praeterea, quem audiamus.
            </p>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed vos squalidius, illorum vides quam niteat oratio. Quoniam, si dis placet, ab Epicuro loqui discimus. Sed tempus est, si videtur, et recta quidem ad me. Duo Reges: constructio interrete. Illa tamen simplicia, vestra versuta. Universa enim illorum ratione cum tota vestra confligendum puto.
            </p>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit
              {' '}<Link to="/contact">lorem ipsum</Link> dolor sit amet.
            </p>
          </div>
        </section>
        <section className="container fadeInUp profile">
          <div className="col-5-of-12">
            <h4>> experience:</h4>
          </div>
          <div className="col-7-of-12">
            <ul className="experience">
              <li>
                <h4>
                  <span>Zalando</span>
                  <span>2016 - currently</span>
                </h4>
                <span>Lead Designer</span>
              </li>
              <li>
                <h4>
                  <span>SketchRunner</span>
                  <span>2016 - currently</span>
                </h4>
                <span>Lead Designer</span>
              </li>
              <li>
                <h4>
                  <span>Cookies</span>
                  <span>2015 - 2016</span>
                </h4>
                <span>Product Designer</span>
              </li>
              <li>
                <h4>
                  <span>FLIO</span>
                  <span>2015</span>
                </h4>
                <span>UX Designer</span>
              </li>
              <li>
                <h4>
                  <span>MarleySpoon</span>
                  <span>2014 & 2015</span>
                </h4>
                <span>Lead Designer</span>
              </li>
              <li>
                <h4>
                  <span>Shopnow</span>
                  <span>2014</span>
                </h4>
                <span>Product Designer</span>
              </li>
              <li>
                <h4>
                  <span>Stylemarks</span>
                  <span>2013–2014</span>
                </h4>
                <span>UX Designer</span>
              </li>
            </ul>
          </div>
        </section>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/javascripts/pages/About.js